import React from 'react'

const SignatureInline = ({contactInfo, disclaimer, sharedStyles}) => {
	const {headingStyle, pStyle} = sharedStyles;

	return(
		
		<div className="signatureBlock" id="inlineSignature">
			<p style={headingStyle}><strong>
			{contactInfo.name}
			</strong></p>

			<div style={pStyle}>

				{!!(contactInfo.pronouns) && 
				<span style={pStyle}>Pronouns: {contactInfo.pronouns}, </span> }

				{!!(contactInfo.title) && 
				<span>{contactInfo.title}</span> }

				{!!(contactInfo.department && contactInfo.title) &&
				<span>, </span> }

				{!!(contactInfo.department) && 
				<span>{contactInfo.department}</span> }
			</div>

			{!!(contactInfo.image === "Yes") && 
				<div>
					<img src="https://www.unco.edu/_resources/images/email-signatures/unc-signature2.jpg" alt="University of Northern Colorado" />
				</div>
			}

			<div style={pStyle}>

				{!!(contactInfo.building) && 
				<span>{contactInfo.building}</span> }

				{!!(contactInfo.campusbox) && 
				<span>| Campus Box {contactInfo.campusbox}</span> }

				{!!(contactInfo.city) && 
				<span>| {contactInfo.city}</span> }
			</div>
		
			<div style={pStyle}>
				{!!(contactInfo.phoneoffice) &&
				<span>O: {contactInfo.phoneoffice}</span>}

				{!!(contactInfo.phonecell) &&
				<span> | C: {contactInfo.phonecell}</span>}

				{!!(contactInfo.phonefax) &&
				<span> | F: {contactInfo.phonefax}</span>}

			</div>

			{!!(disclaimer) &&
				<table border="0" cellPadding="0" cellSpacing="0">
					<tbody>
						<tr>
							<td height="24" style={sharedStyles.height24}></td>
						</tr>
						<tr>
							<td colSpan="2">
								<p className="disclaimer" style={sharedStyles.disclaimer}>
									{disclaimer}
								</p>
							</td>
						</tr>
						<tr>
							<td height="24" style={sharedStyles.height24}></td>
						</tr>
					</tbody>
				</table>
			}
		</div>

	)
}

export default SignatureInline;